<template>
  <div class="head" @mouseleave="resetVisible">
    <ul class="menu">
      <li
        @mouseenter="resetVisible"
        @click="toHome"
        :class="parentNavIndex === 0 ? 'chooseNavActive' : ''"
      >
        <a>{{ $t('head.home') }}</a>
      </li>
      <li
        @mouseenter="showAboutUsVisible"
        @click="toAboutUs"
        :class="parentNavIndex === 1 ? 'chooseNavActive' : ''"
      >
        <a>{{ $t('aboutUs.about_us') }}</a>
      </li>
      <li
        @mouseenter="showProductVisible"
        @click="toProduct"
        :class="parentNavIndex === 2 ? 'chooseNavActive' : ''"
      >
        <a>{{ $t('product.product') }}</a>
      </li>
      <!-- <li
        @mouseenter="resetVisible"
        :class="parentNavIndex === 3 ? 'chooseNavActive' : ''"
        @click="toNewProduct"
      >
        <a>{{ $t('product.new_product') }}</a>
      </li> -->
      <li
        @mouseenter="showNewsVisible"
        @click="toNewsInfo"
        :class="parentNavIndex === 4 ? 'chooseNavActive' : ''"
      >
        <a>{{ $t('news.News_and_Information') }}</a>
      </li>
      <li
        @mouseenter="showContactUsVisible"
        @click="toContactUs"
        :class="parentNavIndex === 5 ? 'chooseNavActive' : ''"
      >
        <a>{{ $t('contactUs.contact_us') }}</a>
      </li>
    </ul>
    <div
      @mouseenter="resetVisible"
      @mouseleave="resetVisible"
      class="resetVisible"
    ></div>

    <div class="searchRight">
      <div class="emply"></div>
      <div
        class="search"
        @mouseenter="resetVisible"
        @mouseleave="hideSearchVisible"
      >
        <!-- <el-input
        placeholder="请输入商品名称"
        v-model="keyWord"
        class="input-with-select"
      >
        <el-select v-model="select" slot="prepend" placeholder="请选择">
          <el-option label="餐厅名" value="1"></el-option>
          <el-option label="订单号" value="2"></el-option>
          <el-option label="用户电话" value="3"></el-option>
        </el-select>
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input> -->
        <input
          type="text"
          :placeholder="$t('head.Please_enter_the_product_name')"
          v-model.trim="keyWord"
          @mouseenter="keyWordFocus"
          @keyup.enter="search"
          class="inputSearch"
        />
        <div class="iconSearch" @click="search">
          <a><i class="el-icon-search"></i></a>
        </div>

        <!-- <div v-if="searchCondition" class="searchCondition">11</div> -->
        <div class="searchCondition" v-show="searchVisible">
          <span class="searchCate">{{ $t('head.Search_Type') }}：</span>
          <el-checkbox-group v-model="checkList" @change="checkListChange">
            <el-checkbox label="0" class="block-checkbox">{{
              $t('product.product')
            }}</el-checkbox>
            <el-checkbox label="1" class="block-checkbox">
              {{ $t('Manual.Handbook_Resources') }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </div>
    <div class="CEchange">
      <a class="CEactive" @click="(e) => typeChange('zh-CN', e)">中</a> |
      <a @click="(e) => typeChange('en-US', e)">EN</a>
    </div>

    <div class="product" @mouseleave="hideProductVisible" v-if="productVisible">
      <div
        class="productCate"
        v-for="(item, index) in productSecondLevelList"
        :key="index"
      >
        <p class="cate" @click="toProductList(index + 1, item.id, item.url)">
          {{ item.data.name }}
        </p>
        <ul class="cateList">
          <li
            v-for="(it, i) in item.children"
            :key="i"
            @click="toCateList(it.data.id, it.data.name, it.data.url)"
          >
            {{ it.data.name }}
          </li>
        </ul>
      </div>
    </div>

    <div class="aboutUs" @mouseleave="hideAboutUsVisible" v-if="aboutUsVisible">
      <div class="aboutUsList">
        <div @click="toAboutUsList(0)">{{ $t('head.Company_Profile') }}</div>
        <div @click="toAboutUsList(1)">
          {{ $t('head.development_history') }}
        </div>
        <div @click="toAboutUsList(2)">{{ $t('head.Company_strength') }}</div>
      </div>
    </div>
    <!-- 联系我们 -->
    <div
      class="contactUs"
      @mouseleave="hideContactUsVisible"
      v-if="contactUsVisible"
    >
      <div class="mapBox">
        <baidu-map
          class="map"
          :center="center"
          :zoom="zoom"
          :scroll-wheel-zoom="true"
          @ready="handler"
        >
          <bm-marker
            :position="{ lng: center.lng, lat: center.lat }"
            :dragging="false"
            animation="BMAP_ANIMATION_BOUNCE"
          >
            <bm-label
              :content="$t('head.company')"
              :labelStyle="{
                border: 0,
                fontSize: '12px',
                backgroundColor: 'transparent',
              }"
              :offset="{ width: -35, height: -30 }"
            />
          </bm-marker>
          <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
        </baidu-map>
      </div>

      <div class="contactUsIcon">
        <div @click="toContactUsList(0)">
          <img src="../../assets/images/contactUs/13.png" />
          <span>{{ $t('head.Sales_Contact') }}</span>
        </div>
        <div @click="toContactUsList(1)">
          <img src="../../assets/images/contactUs/14.png" />
          <span>{{ $t('head.Service_Support') }}</span>
        </div>
        <div @click="toContactUsList(2)">
          <img src="../../assets/images/contactUs/15.png" />
          <span>{{ $t('head.MESSAGE') }}</span>
        </div>
        <div @click="toContactUsList(3)">
          <img src="../../assets/images/contactUs/16.png" />
          <span>{{ $t('head.online_purchase') }}</span>
        </div>
      </div>
    </div>

    <!-- 新闻咨询 -->
    <div class="aboutUs" @mouseleave="hideNewsVisible" v-if="newsVisible">
      <div class="newsList">
        <div @click="toNewsInfoList(0)">
          {{ this.$t('news.cateTabList[0]') }}
        </div>
        <div @click="toNewsInfoList(1)">
          {{ this.$t('news.cateTabList[1]') }}
        </div>
        <div @click="toNewsInfoList(2)">
          {{ this.$t('news.cateTabList[2]') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ProductCategoryFind } from '@/http/head';

export default {
  props: {
    parentNavIndex: Number,
  },
  data() {
    return {
      type: 'zh-CN',
      productVisible: false,
      aboutUsVisible: false,
      contactUsVisible: false,
      newsVisible: false,
      searchVisible: false,
      center: { lng: 120.526064, lat: 31.236531 },
      zoom: 20,
      keyWord: '',
      select: '',
      checkList: ['0'],
      productSecondLevelList: [],
      categoryImg: '',
      productTypeIndex: null,
    };
  },
  methods: {
    typeChange(type, e) {
      this.$i18n.locale = type;
      this.$forceUpdate();
      this.type = type;
      document
        .querySelector('.CEchange .CEactive')
        .classList.remove('CEactive');
      e.target.classList.add('CEactive');
      localStorage.setItem('web_tasi_lang', this.type);
      this.$emit('langChange', type);
      if (type == 'zh-CN') {
        console.log(window.location.href);
        const newUrl = this.removeUrlParameter(window.location.href, 'lang');
        console.log(newUrl);
        // 使用pushState更新浏览器历史记录，但不触发页面刷新
        window.history.pushState({ path: newUrl }, '', newUrl);
      }
      location.reload();
      this.$forceUpdate();
    },
    removeUrlParameter(url, parameter) {
      const urlParts = url.split('?');
      if (urlParts.length >= 2) {
        const params = new URLSearchParams(urlParts[1]);
        params.delete(parameter);
        return `${urlParts[0]}?${params.toString()}`;
      }
      return url;
    },
    resetVisible() {
      this.productVisible = false;
      this.aboutUsVisible = false;
      this.contactUsVisible = false;
      this.newsVisible = false;
    },
    showProductVisible() {
      this.resetVisible();
      this.productVisible = true;
    },
    hideProductVisible() {
      this.productVisible = false;
    },
    showAboutUsVisible() {
      this.resetVisible();
      this.aboutUsVisible = true;
    },
    hideAboutUsVisible() {
      this.aboutUsVisible = false;
    },
    showContactUsVisible() {
      this.resetVisible();
      this.contactUsVisible = true;
    },
    hideContactUsVisible() {
      this.contactUsVisible = false;
    },
    showNewsVisible() {
      this.resetVisible();
      this.newsVisible = true;
    },
    hideNewsVisible() {
      this.newsVisible = false;
    },
    handler({ BMap, map }) {
      console.log(BMap, map);
      // this.center.lng = 120.526064;
      // this.center.lat = 31.236531;
      // this.zoom = 15;
    },
    hideSearchVisible() {
      this.searchVisible = false;
    },
    keyWordFocus() {
      this.searchVisible = true;
    },
    checkListChange() {
      console.log(this.checkList);
      if (this.checkList.length > 1) {
        this.checkList = this.checkList.slice(-1);
      }
    },
    toHome() {
      if (this.$route.path.includes('home')) {
        return;
      }
      this.$router.push('/home');
    },
    toProduct() {
      if (this.$route.path.includes('product/main')) {
        return;
      }
      this.$router.push('/product/main');
    },
    toProductList(type, productTypeId, url) {
      // console.log(url);
      // if (url) {
      //   return;
      // }
      this.productTypeIndex = type - 1;
      if (this.$route.path.includes('product/main')) {
        this.$emit('changeCateTab', type, productTypeId, url);
        return;
      }
      this.$router.push({
        path: '/product/main',
        query: { type, categoryId: productTypeId, imgUrl: url },
      });
    },
    toAboutUs() {
      if (this.$route.path.includes('aboutUs')) {
        return;
      }
      this.$router.push('/aboutUs');
    },
    toAboutUsList(type) {
      if (this.$route.path.includes('aboutUs')) {
        this.$emit('changeCateTab', type);
        return;
      }
      this.$router.push({ path: '/aboutUs', query: { type } });
    },
    toContactUs() {
      if (this.$route.path.includes('contactUs')) {
        return;
      }
      this.$router.push('/contactUs');
    },
    toContactUsList(type) {
      if (this.$route.path.includes('contactUs')) {
        this.$emit('changeCateTab', type);
        return;
      }
      this.$router.push({ path: '/contactUs', query: { type } });
    },
    toNewsInfo() {
      if (this.$route.path.includes('newsInfo')) {
        return;
      }
      this.$router.push('/newsInfo');
    },
    toNewsInfoList(type) {
      if (this.$route.path.includes('newsInfo')) {
        this.$emit('changeCateTab', type);
        return;
      }
      this.$router.push({ path: '/newsInfo', query: { type } });
    },
    toNewProduct() {
      // this.$emit('toNewProduct');
      this.$router.push('/newProduct');
    },

    async getProductList() {
      this.categoryImg = null;
      const res = await ProductCategoryFind(2);
      this.productSecondLevelList = JSON.parse(res.data.jsonString);
      console.log(this.productSecondLevelList);
      console.log(this.$router.query);
      console.log(this.$route);
      if (
        this.$route.path.includes('searchProduct') &&
        this.$route.query.productTypeId
      ) {
        for (let i = 0; i < this.productSecondLevelList.length; i++) {
          if (this.productSecondLevelList[i].children) {
            for (
              let j = 0;
              j < this.productSecondLevelList[i].children.length;
              j++
            ) {
              if (
                this.$route.query.productTypeId ==
                this.productSecondLevelList[i].children[j].id
              ) {
                this.categoryImg =
                  this.productSecondLevelList[i].children[j].url;
                this.$emit('getUrl', this.categoryImg);
                return;
              }
            }
          }
        }
      } else if (this.$route.path.includes('product/main')) {
        console.log(this.productTypeIndex);
        if (this.productTypeIndex) {
          for (let i = 0; i < this.productSecondLevelList.length; i++) {
            if (
              this.productSecondLevelList[this.productTypeIndex].id ==
              this.productSecondLevelList[i].id
            ) {
              this.categoryImg = this.productSecondLevelList[i].url;
              this.$emit('getUrl', this.categoryImg);
              return;
            }
          }
        }
      }
    },
    search() {
      console.log(this.checkList);
      if (this.checkList.length === 0) {
        this.$message({
          message: '请选择要查询的类型',
          type: 'warning',
        });
        return;
      }
      if (this.checkList[0] == '0') {
        this.$router.push({
          path: '/product/searchProduct',
          query: { keyWord: this.keyWord },
        });
      } else if (this.checkList[0] == '1') {
        this.$router.push({
          path: '/product/searchManual',
          query: { keyWord: this.keyWord },
        });
      }
      this.checkList = ['0'];
    },
    toCateList(productTypeId, keyWord, url) {
      console.log(productTypeId);
      this.resetVisible();
      this.$router.push({
        path: '/product/searchProduct',
        query: {
          productTypeId: productTypeId,
          keyWordShow: keyWord,
          imgUrl: url,
        },
      });
    },
  },
  created() {
    if (this.$route.query.lang == 'en-US') {
      localStorage.setItem('web_tasi_lang', 'en-US');
      this.$i18n.locale = 'en-US';
    }
  },
  mounted() {
    let lang = localStorage.getItem('web_tasi_lang') || 'zh-CN';
    let a = document.querySelectorAll('.CEchange a');
    document.querySelector('.CEchange .CEactive').classList.remove('CEactive');
    if (lang == 'zh-CN') {
      a[0].classList.add('CEactive');
    } else {
      a[1].classList.add('CEactive');
    }
    this.getProductList();
    console.log(this.parentNavIndex);
    console.log('app');
    var url = window.location.href;
    // 修改query参数
    // var newQuery = `detailId=${id}`;
    // 拼接新的URL
    // var newUrl = url.split('?')[0] + '?' + newQuery;
    var newUrl = url.split('?')[0];
    console.log(url);
    console.log(newUrl);
    if (lang == 'en-US') {
      const urlParams = new URLSearchParams(window.location.search);
      // 设置或更新参数
      urlParams.set('lang', 'en-US');
      // 构建新的URL
      const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
      // 使用pushState更新浏览器历史记录，但不触发页面刷新
      window.history.pushState({ path: newUrl }, '', newUrl);
    }
  },

  watch: {
    $route(to) {
      console.log(to);
    },
  },
};
</script>

<style scoped lang="less">
@import '../../theme';
.head {
  height: 5vw;
  background-image: url('../../assets/images/head/导航栏.jpg');
  background-size: 100% 100%;
  padding-left: 23vw;
  display: flex;
  align-items: center;
  position: relative;
  .product {
    position: absolute;
    top: 5vw;
    left: 0px;
    right: 0px;
    height: 500px;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    color: #fff;
    padding-left: 20vw;
    padding-right: 5vw;
    padding-top: 40px;
    display: flex;
    .productCate {
      flex: 1;
      .cate {
        margin-bottom: 20px;
        font-weight: bold;
        font-size: 20px;
        cursor: pointer;
      }
      .cateList {
        font-size: 18px;
        font-weight: lighter;
        color: #d5d5d5;
        li:hover {
          color: @themeColor;
          cursor: pointer;
        }
      }
    }
  }
  .aboutUs {
    position: absolute;
    top: 5vw;
    left: 0px;
    right: 0px;
    height: 80px;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    color: #fff;
    .aboutUsList {
      width: 1000px;
      margin: auto;
      font-weight: bold;
      height: 100%;
      font-size: 20px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      div:hover {
        color: @themeColor;
      }
    }
  }
  .contactUs {
    position: absolute;
    top: 5vw;
    left: 0px;
    right: 0px;
    padding: 70px 10vw;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    color: #fff;
    display: flex;
    .mapBox {
      border-radius: 15px;
      width: 510px;
      height: 335px;
      overflow: hidden;
      margin-right: 8vw;
      .map {
        width: 100%;
        height: 100%;
      }
    }
    .contactUsIcon {
      display: flex;
      justify-content: space-around;
      flex: 1;
      div {
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 80px;
          height: 80px;
        }
      }
      div:hover {
        color: @themeColor;
      }
    }
  }
  .newsList {
    width: 400px;
    margin: auto;
    font-weight: bold;
    height: 100%;
    font-size: 20px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    div:hover {
      color: @themeColor;
    }
  }
}
// .menu li:nth-child(2):hover {
//   .product {
//     display: block;
//   }
// }
.menu {
  display: flex;
  color: #fff;
  font-size: 20px;
  height: 100%;
  li {
    height: 100%;
    // line-height: 95px;
    padding: 0px 10px;
    margin: 0px 10px;
    display: flex;
    align-items: center;
    // a {
    //   display: block;
    // }
  }
  li:hover {
    border-bottom: 3px solid @themeColor;
    cursor: pointer;
  }
}
.resetVisible {
  width: 10px;
  height: 100%;
  // background-color: aquamarine;
}
.searchRight {
  display: flex;
  flex: 1;
  margin-right: 90px;
  .emply {
    flex: 1;
  }
}
.search {
  // margin-left: 5vw;
  display: flex;
  // position: absolute;
  // right: 100px;
  width: 250px;
  .inputSearch {
    height: 40px;
    width: 200px;
    border-radius: 8px 0px 0px 8px;
    outline: none;
    border: none;
    font-size: 16px;
    padding-left: 10px;
  }
  .iconSearch {
    background-color: @themeColor;
    height: 40px;
    width: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0px 8px 8px 0px;
    i {
      font-size: 28px;
      color: #fff;
    }
  }
}
/deep/ .searchCondition {
  position: absolute;
  background-color: #fff;
  top: 3vw;
  width: 200px;
  border-radius: 0px 0px 8px 8px;
  z-index: 1000;
  padding: 10px;
  .searchCate {
    font-size: 14px;
  }
  .block-checkbox {
    display: block;
    // margin-bottom: 5px; /* 添加间距 */
  }
  /* 修改选中状态下的背景颜色 */
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: @themeColor; /* 你想要的任何颜色 */
    border-color: @themeColor; /* 可以设置与背景颜色一致 */
  }
  .el-checkbox .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: @themeColor; /* 默认未选中时的边框颜色 */
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: @themeColor;
  }
  .el-checkbox__inner:hover {
    border-color: @themeColor;
  }
  /* 修改选中状态下对勾的颜色 */
  .el-checkbox__input.is-checked .el-checkbox__inner::after {
    color: #fff; /* 对勾的颜色 */
  }
}
.CEchange {
  position: absolute;
  right: 20px;
  color: #a8a8a8;
  a {
    cursor: pointer;
  }
}
.CEactive {
  color: #fff;
}

.chooseNavActive {
  border-bottom: 3px solid @themeColor;
}
</style>
